<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JG61fs/tc-custom/9781398423251.jpg?1705056319292" alt="This image is the cover for the book Teaching in Tongren, China"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Teaching in Tongren, China
      </h1>
      <p class="bookDescription body article font2">
        <p>Since the accession of Xi Jinping as the supreme Chinese leader, the empire has been becoming increasingly aggressive, to the point of bullying. Its so-called “Belt and Road Initiative” seems designed to lure poorer nations into a debt trap, forcing them into subservience to Chinese demands. Its huge fishing fleet is encroaching upon the legitimate fishing grounds of many other nations. It is seeking to expand its territory to include almost the entire South China Sea, Taiwan, parts of India, Japanese islands, etc. Indeed most of “China” is conquered territory. Chinese efforts to control Australia have been extraordinary. Yet is this the whole story? This book describes just how wonderful the Chinese people can be. The students I taught at Tongren University were amongst the best I have taught anywhere. It was not hard to love them. The town of Tongren is itself quite beautiful, surrounded by conical hills and built around the green, winding Li Jiang River.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Greg McEnnally
      </h2>
      
      <p class="authorDescription body article">Greg McEnnally was a Science and Maths teacher for many years in Australia and Papua New Guinea. Subsequently, he shifted to teaching English as a second language because of its need in Indonesia. From there he moved to China, teaching in Fuzhou, Fujian Province, Tongren in Guizhou Province and Chongqing. This book is about his experiences teaching in Tongren between 2008 and 2011.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0cec6c4a